import { trackEvent } from "./gtm";

// Event names must match the Custom Event triggers in Google Tag Manager
const salonContent = (tenantId: string | number | undefined) => ({
  content_type: "salon",
  content_ids: tenantId === undefined ? [] : [String(tenantId)],
});

/** A visitor opened a salon's booking page (Meta: ViewContent). */
export const trackViewContent = (
  tenantId: string | number | undefined,
  tenantName?: string,
) =>
  trackEvent("view_content", {
    ...salonContent(tenantId),
    content_name: tenantName,
  });

/** A visitor picked their first service (Meta: InitiateCheckout). */
export const trackBeginBooking = (tenantId: string | number | undefined) =>
  trackEvent("begin_booking", salonContent(tenantId));

/** A booking or request was sent (Meta: Lead). The event_id lets a server-side event dedupe against it. */
export const trackBookingSubmitted = (
  tenantId: string | number | undefined,
  bookingId: number,
  isAutoBooking: boolean,
) =>
  trackEvent("booking_submitted", {
    event_id: `booking-${bookingId}`,
    ...salonContent(tenantId),
    is_auto_booking: isAutoBooking,
  });
